document.addEventListener('DOMContentLoaded', () => {

  const registerFormPassword = document.querySelector('#RegisterForm-password')
  const registerSubmitButton = document.querySelector('[data-main-register-submit-button]')
  if (!registerSubmitButton || !registerFormPassword) {
    console.log('register form elements not found')
    return
  }

  function calculatePasswordStrength(password) {
    let strength = 0
    if (password.length > 7) strength += 1 // Length criteria
    if (/[A-Z]/.test(password)) strength += 1 // Uppercase letter
    if (/[a-z]/.test(password)) strength += 1 // Lowercase letter
    if (/[0-9]/.test(password)) strength += 1 // Digit
    if (/[^A-Za-z0-9]/.test(password)) strength += 1 // Special character
    return strength
  }

  registerFormPassword.addEventListener('input', function() {
    const strengthMessage = document.getElementById('strength-message')
    const password = this.value
    const strength = calculatePasswordStrength(password)
    if (strength <= 4) {
        registerFormPassword.style.borderColor = 'red'
        registerSubmitButton.disabled = true
        registerSubmitButton.setAttribute('aria-disabled', 'true')
        strengthMessage.innerHTML = 'Please enter a password using numbers, one special character, upper and lower case letters and minimum of 8 character'
    } else {
        registerFormPassword.style.borderColor = 'blue'
        registerSubmitButton.disabled = false
        registerSubmitButton.setAttribute('aria-disabled', 'false')
        strengthMessage.innerHTML = ''
    }
  })

})